export default {
    save: 'Save',
    save_and_close: 'Save and close',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    add: 'Add',

    search: 'Search',
    reset: 'Reset',
    clear: 'Clear',

    actions: 'Actions',
    mass_action: 'Bulk actions',

}
